import { V4Client } from "../Vlaanderen/geolocation-client";

export interface IAddressSearcherSearchOptions {
    term: string;
}

export default class AddressSearcher {
    constructor() {
    }

    public search(options: IAddressSearcherSearchOptions): Promise<any> {

        const geoLocationService = new V4Client();

        return geoLocationService.location(options.term,null,null,null,5);
    }

}


